//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pick from 'lodash.pick';
import { queryIdTree } from '@/api/api';
export default {
  name: 'DeptBaseInfo',
  components: {},
  data: function data() {
    return {
      departTree: [],
      id: '',
      model: {},
      visible: false,
      disable: true,
      treeData: [],
      form: this.$form.createForm(this),
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 3
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      }
    };
  },
  created: function created() {
    this.loadTreeData();
  },
  methods: {
    loadTreeData: function loadTreeData() {
      var _this = this;

      queryIdTree().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];

            _this.treeData.push(temp);
          }
        }
      });
    },
    open: function open(record) {
      var _this2 = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      console.log("record:");
      console.log(record);
      this.$nextTick(function () {
        _this2.form.setFieldsValue(pick(record, 'departName', 'parentId', 'orgCode', 'departOrder', 'mobile', 'fax', 'address', 'memo'));
      });
    },
    clearForm: function clearForm() {
      this.form.resetFields();
      this.treeData = [];
    }
  }
};